import React from 'react'
import logoBusquedadMisteriosa from '../../../assets/images/logoBusquedadMisteriosa.png'
import personajes from '../../../assets/images/personajes1A.png'
import premioA from '../../../assets/images/premio1CO.png'
import premioB from '../../../assets/images/premio2CO.png'
import premioACL from '../../../assets/images/premioACL.png'
import premioBCL from '../../../assets/images/premioBCL.png'
import premioCCL from '../../../assets/images/premioCCL.png'
import premioAAR from '../../../assets/images/premio1AR.png'
import premioBAR from '../../../assets/images/premio2AR.png'
import premioAPY from '../../../assets/images/premio1PY.png'
import premioARD from '../../../assets/images/premio1RD.png'
import premioAPR from '../../../assets/images/premio1PR.png'
import Button from '../../atoms/button/button'
import { navigate } from 'gatsby'
import './bannerSection.scss'

const BannerSection = props => {
  const { mobile } = props
  const textExplain = () => {
    switch (process.env.LOCALE) {
      case 'es-AR':
        return [
          <p>
            <span>Buscá y señalá a:</span> Menstruación, Flujo y Útero
            <span> ¡hacé click para seleccionarlos </span>y lográ el mayor
            puntaje en el menor tiempo posible!
          </p>,
        ]
      case 'es-PY':
        return [
          <p>
            <span>Buscá y señalá a:</span> Menstruación, Flujo y Útero
            <span> ¡hacé 1 click para seleccionarlos </span>y lográ el mayor
            puntaje en el menor tiempo posible!
          </p>,
        ]
      case 'es-DO':
        return [
          <p>
            <span>Busca y señala a:</span> Menstruación, Flujo y Útero
            <span> ¡Haz 1 clic para seleccionarlos </span>y logra el mayor
            puntaje en el menor tiempo posible!
          </p>,
        ]
      case 'es-PR':
        return [
          <p style={{ maxWidth: '324px' }}>
            <span>Busca y señala a:</span> Menstruación, Flujo y Útero
            <span>
              {' '}
              que están camuflados en nuestro Cementerio Misterioso.{' '}
            </span>{' '}
            ¡Haz 1 clic para seleccionarlos y logra el mayor puntaje en el menor
            tiempo posible!
          </p>,
        ]
      case 'es-BO':
        return [
          <p style={{ maxWidth: '324px' }}>
            <span>Busca y señala a:</span> Menstruación, Flujo y Útero
            <span>
              {' '}
              que están camuflados en nuestro Cementerio Misterioso.{' '}
            </span>{' '}
            ¡Haz 1 clic para seleccionarlos y logra el mayor puntaje en el menor
            tiempo posible!
          </p>,
        ]
      default:
        return [
          <p>
            <span>Busca, señala y encuentra a:</span> Menstruación, Flujo y
            Útero en el menor tiempo posible
            <span> y logra el mayor puntaje.</span>
          </p>,
        ]
    }
  }

  const textRedem = () => {
    switch (process.env.LOCALE) {
      case 'es-CO':
        return ['redimiendo']
      case 'es-DO':
        return ['redimiendo']
      default:
        return ['canjeando']
    }
  }

  const textPremios = () => {
    switch (process.env.LOCALE) {
      case 'es-AR':
        return [
          <>
            <h3>
              ¡EL MEJOR <span>PUNTAJE GANARÁ UN</span>
              <br />
              <span className="textPremio">Fabuloso parlante bluetooth!</span>
            </h3>
            <img src={premioAAR} alt="imagen premio 1" />
            <h3 className="botoomH3">
              SI ESTÁS EN NUESTRO TOP 10 <span>PODRÁS GANAR</span>
              <br />
              <span className="textPremio">
                Una bolsa de productos y merchandising
              </span>
            </h3>
            <img className="es-AR" src={premioBAR} alt="imagen premio 1" />
          </>,
        ]
      case 'es-PY':
        return [
          <>
            <h3 style={{ maxWidth: '125px' }}>
              SI ESTÁS EN NUESTRO TOP 3, <span>PODRÁS GANAR</span>
              <br />
              <span className="textPremio">
                1 Kit Nosotras + 1 Giftcard de Forever 21 por GS 250.000
              </span>
            </h3>
            <img className="es-PY" src={premioAPY} alt="imagen premio 1" />
          </>,
        ]
      case 'es-DO':
        return [
          <>
            <h3 style={{ maxWidth: '182px' }}>
              ¡SI ESTÁS EN NUESTRO TOP 10, <span>PODRÁS GANAR</span>
              <br />
              <span className="textPremio">un fabuloso Kit de Nosotras!</span>
            </h3>
            <img
              style={{ width: '175px', height: '170px' }}
              src={premioARD}
              alt="imagen premio 1"
            />
          </>,
        ]
      case 'es-PR':
        return [
          <>
            <h3 style={{ maxWidth: '100%', letterSpacing: '0.1rem' }}>
              SI ESTÁS ENTRE LAS 3 GANADORAS CON MEJORES PUNTAJES,
              <span>PODRÁS GANAR</span>
              <br />
              <span className="textPremio">
                un mes de productos Nosotras + regalos sorpresa
              </span>
            </h3>
            <img
              style={{ width: '203px', height: '203px' }}
              src={premioAPR}
              alt="imagen premio 1"
            />
          </>,
        ]
      case 'es-BO':
        return [
          <>
            <h3 style={{ maxWidth: '100%', letterSpacing: '0.1rem' }}>
              PARTICIPA <br />
              <span style={{ color: 'white', fontSize: '18px' }}>
                LAS VECES QUE QUIERAS
              </span>
            </h3>
          </>,
        ]
      default:
        return [
          <>
            <h3>
              DEL TOP 1 AL 5 <span>GANARÁN</span>
              <br />
              <span className="textPremio">
                Una cámara instantánea Instax Polaroid
              </span>
            </h3>
            <img src={premioA} alt="imagen premio 1" />
            <h3 className="botoomH3">
              Del top <br />6 al 10 <span>ganarán</span>
              <br />
              <span className="textPremio">Un kit Nosotras</span>
            </h3>
            <img src={premioB} alt="imagen premio 1" />
          </>,
        ]
    }
  }

  return (
    <div className="f-busquedadMisteriosa-container">
      <div className="f-busquedadMisteriosa-container__content">
        {process.env.LOCALE === 'es-AR' || process.env.LOCALE === 'es-PY' ? (
          <h1>Participá y ganá en la</h1>
        ) : process.env.LOCALE === 'es-DO' ||
          process.env.LOCALE === 'es-PR' ||
          process.env.LOCALE === 'es-BO' ? (
          <h1>Participa y gana en la</h1>
        ) : (
          <h1>
            Este <span>HALLOWEEN</span>,<br /> participa y gana en la
          </h1>
        )}

        {mobile && (
          <img
            src={logoBusquedadMisteriosa}
            className="imgMobile"
            alt="logo busquedad misteriosa"
          />
        )}
        <div className="f-busquedadMisteriosa-container__content__section">
          <div className="f-busquedadMisteriosa-container__content__section__colum1">
            <img src={personajes} alt="personajes busquedad" />
            {textExplain()}
          </div>
          <div className="f-busquedadMisteriosa-container__content__section__colum2">
            {!mobile && (
              <img
                src={logoBusquedadMisteriosa}
                alt="logo busquedad misteriosa"
              />
            )}
            <Button
              text="¡A JUGAR!"
              color="textOrange"
              size="big"
              onClick={() => navigate('/juega')}
            />
          </div>
          <div className="f-busquedadMisteriosa-container__content__section__colum3">
            {process.env.LOCALE === 'es-PR' ||
            process.env.LOCALE === 'es-BO' ? null : (
              // muestra el bloque Top si no es PR
              <div className="f-busquedadMisteriosa-container__content__section__colum3__top">
                <h3>
                  {process.env.LOCALE === 'es-AR' ||
                  process.env.LOCALE === 'es-PY'
                    ? 'PARTICIPÁ'
                    : 'PARTICIPA'}
                </h3>
                {mobile ? (
                  <p className={`${process.env.LOCALE}`}>
                    las veces que{' '}
                    {process.env.LOCALE === 'es-PY' ? 'querás' : 'quieras'}{' '}
                    {textRedem()}{' '}
                  </p>
                ) : (
                  <p className={`${process.env.LOCALE}`}>
                    las veces que{' '}
                    {process.env.LOCALE === 'es-PY' ? 'querás' : 'quieras'}
                    <br /> {textRedem()} <br /> cada vez.
                  </p>
                )}
              </div>
            )}
            <div
              className={`f-busquedadMisteriosa-container__content__section__colum3__bot ${process.env.LOCALE}`}
            >
              {process.env.LOCALE === 'es-CL' ? ( //muestra 3 columnas porqe fue chile
                <>
                  <div className="f-participaSection-container__wrapper__content__section6__top__premio banner">
                    <h3>
                      EL MEJOR PUNTAJE <span>GANARA</span>
                    </h3>
                    <p>
                      Un kit para cejas de Anastasia Beverly Hills y una paleta
                      de sombras de Huda Beauty
                    </p>
                    <img src={premioACL} alt="premio chile" />
                  </div>
                  <div className="f-participaSection-container__wrapper__content__section6__top__premio banner">
                    <h3>
                      EL SEGUNDO Y TERCER LUGAR <span>GANARÁN</span>
                    </h3>
                    <p>Un kit de cejas de Anastasia Beverly Hills</p>
                    <img src={premioBCL} alt="premio chile" />
                  </div>
                  <div className="f-participaSection-container__wrapper__content__section6__top__premio banner">
                    <h3>
                      DEL TOP 4 AL 10 <span>GANARÁN</span>
                    </h3>
                    <p>Un kit de productos Nosotras</p>
                    <img src={premioCCL} alt="premio chile" />
                  </div>
                </>
              ) : (
                textPremios()
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default BannerSection
